import { useEffect, useState } from "react";
import Modal from "../modal/modal"; // твой универсальный Modal с actions

const Get_Workers = () => {
  const [workers, setWorkers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalMessage, setModalMessage] = useState(null); // {id, title, text, actions}

  const fetchWorkers = () => {
    fetch("/api/get_workers.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setWorkers(data.workers);
      });
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  const confirmDelete = (id, fullName) => {
    setModalMessage({
      id,
      title: "Ցանկանում եք ջնջել այս թեկնածուին?",
      text: `Դուք ջնջելու եք թեկնածուին "${fullName}"`,
      actions: [
        {
          label: "Ջնջել",
          success: true,
          onClick: () => handleDelete(id),
        },
        {
          label: "Չեղարկել",
          success: false,
          onClick: () => setModalMessage(null),
        },
      ],
    });
  };

  const handleDelete = (id) => {
    fetch(`/api/delete_user.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setWorkers((prev) => prev.filter((w) => w.id !== id));
        } else {
          alert("Անհաջող ջնջում: " + data.message);
        }
      })
      .catch((err) => alert("Սխալ: " + err))
      .finally(() => setModalMessage(null));
  };

  const filteredWorkers = workers.filter((w) => {
    const searchLower = search.toLowerCase();
    const fullName = `${w.name} ${w.lastName}`.toLowerCase();
    const email = (w.email ?? "").toLowerCase();
    const status = "—";
    const payment = "—";

    return (
      w.id.toString().includes(searchLower) ||
      fullName.includes(searchLower) ||
      email.includes(searchLower) ||
      status.includes(searchLower) ||
      payment.includes(searchLower)
    );
  });

  return (
    <section className="px-3 sm:px-4 md:px-6">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          actions={modalMessage.actions}
        />
      )}

      {/* Заголовок и поиск */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
          Թեկնածուների բազա
        </h1>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Որոնում..."
          className="w-full sm:w-72 px-4 py-2 rounded-lg bg-white/10 text-white placeholder-white/40 
                     border border-white/20 focus:outline-none focus:border-white 
                     transition text-sm sm:text-base"
        />
      </div>

      {/* Десктопная таблица */}
      <div className="hidden md:block overflow-x-auto rounded-lg border border-white/20 backdrop-blur-xl">
        <table className="min-w-full text-white border-collapse">
          <thead>
            <tr className="bg-white/10">
              <th className="py-3 px-4 border border-white/20 text-left">ID</th>
              <th className="py-3 px-4 border border-white/20 text-left">Անուն Ազգանուն</th>
              <th className="py-3 px-4 border border-white/20 text-left">Էլ․ հասցե</th>
              <th className="py-3 px-4 border border-white/20 text-left">Կարգավիճակ</th>
              <th className="py-3 px-4 border border-white/20 text-left">Վճարում</th>
              <th className="py-3 px-4 border border-white/20 text-left">Գործողություններ</th>
            </tr>
          </thead>

          <tbody>
            {filteredWorkers.map((w) => (
              <tr
                key={w.id}
                className="hover:bg-white/5 transition border border-white/10"
              >
                <td className="py-3 px-4 border border-white/10">{w.id}</td>
                <td className="py-3 px-4 border border-white/10">{w.name} {w.lastName}</td>
                <td className="py-3 px-4 border border-white/10">{w.email}</td>
                <td className="py-3 px-4 border border-white/10">—</td>
                <td className="py-3 px-4 border border-white/10">—</td>
                <td className="py-3 px-4 border border-white/10">
                  <button
                    onClick={() => confirmDelete(w.id, `${w.name} ${w.lastName}`)}
                    className="px-3 py-1 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition"
                  >
                    ջնջել
                  </button>
                </td>
              </tr>
            ))}

            {filteredWorkers.length === 0 && (
              <tr>
                <td colSpan="6" className="py-4 px-4 text-center text-white/50 border border-white/20">
                  Ոչինչ չի գտնվել
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Мобильные карточки */}
      <div className="md:hidden space-y-3">
        {filteredWorkers.map((w) => (
          <div
            key={w.id}
            className="bg-white/5 rounded-lg border border-white/20 p-4 space-y-2"
          >
            <div className="flex justify-between items-start gap-2">
              <span className="text-xs text-white/60">ID: {w.id}</span>
              <div className="flex gap-2 text-xs text-white/50">
                <span>Կարգավիճակ: —</span>
                <span>Վճարում: —</span>
              </div>
            </div>
            
            <h3 className="text-white font-medium text-sm sm:text-base">
              {w.name} {w.lastName}
            </h3>
            
            <p className="text-white/70 text-xs sm:text-sm break-all">
              {w.email || "—"}
            </p>
            
            <button
              onClick={() => confirmDelete(w.id, `${w.name} ${w.lastName}`)}
              className="w-full px-3 py-2 bg-red-600/50 hover:bg-red-600 rounded-lg border border-red-400/30 transition text-white text-sm"
            >
              ջնջել
            </button>
          </div>
        ))}

        {filteredWorkers.length === 0 && (
          <div className="text-center text-white/50 py-8 bg-white/5 rounded-lg border border-white/20">
            Ոչինչ չի գտնվել
          </div>
        )}
      </div>
    </section>
  );
};

export default Get_Workers;